import axios from "axios";
import jwt_decode from "jwt-decode";
import { getToken } from "./tokenCheck.js";

const qs = require("qs");
import {
	ServiceAiInterviewer,
	SSOService,
	ServiceCandidate,
	ServiceCandidateParser,
	serviceRecruitment,
	KeycloakAPIs,
	imageVerify,
	trainingService,
	conv,
	tetrisURL,
	requestSuggestion,
	atsPreview,
	paymentService,
	serviveNotification,
	serviceRequest,
	uploadService,
	websiteRequest,
	notificationAuth,
	getProcessedToken,
	KeynodeService,
	verificationService,
	EmailService,
} from "./request.js";
import { setToken, getRefreshToken, setRefreshToken, getLoginType } from "./tokenCheck.js";
import { Capacitor } from "@capacitor/core";
import store from "../store";

export const getNewAccessToken = async () => {
	const authDataRefreshToken = getRefreshToken();

	let payload = qs.stringify({
		grant_type: "refresh_token",
		client_id: Capacitor.isNativePlatform() ? "hire3x-app" : "vue-test-app",
		refresh_token: authDataRefreshToken,
	});

	try {
		const response = await axios({
			method: "post",
			// url: "https://auth.hire3x.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
			url: "https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Staging
			data: payload,
			headers: {
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
			},
		});
		setToken(response.data.access_token);
		setRefreshToken(response.data.refresh_token);
		store.commit("userVUEX/SET_TOKEN", response.data.access_token);
		localStorage.setItem("accessToken", response.data.access_token);
		if (response.status == 400) {
			// localStorage.clear();
			store.commit("userVUEX/SET_TOKEN", "");
			store.commit("userVUEX/SET_REFRESH_TOKEN", "");
			store.commit("userVUEX/setUserInfo", {});
			store.dispatch("userVUEX/LogOut");

			// location.replace("http://localhost:8080/login?from=admin");
			// location.replace("https://hire3x.com/login");
		}
	} catch (error) {
		// localStorage.clear();
		if (axios.isCancel(error) || ["ECONNABORTED", "ERR_CANCELED"].includes(error.code)) {
			console.warn("Token refresh request cancelled");
			return;
		}
		store.commit("userVUEX/SET_TOKEN", "");
		store.commit("userVUEX/SET_REFRESH_TOKEN", "");
		store.commit("userVUEX/setUserInfo", {});
		store.dispatch("userVUEX/LogOut");
		// location.replace("http://localhost:8080/login?from=admin");
		// location.replace("https://hire3x.com/login");
	}
};

// Refresh Google access token using the backend endpoint
export const refreshGoogleToken = async () => {
	const refreshToken = getRefreshToken();

	try {
		const response = await ServiceCandidate.post("/can/auth/google-refresh/", {
			refresh_token: refreshToken
		});
		if (response.data.type === "Success") {
			const tokens = response.data.data;
			setToken(tokens.id_token);
			store.commit("userVUEX/SET_TOKEN", tokens.id_token);
			localStorage.setItem("accessToken", tokens.id_token);
			// Note: Google doesn't return a new refresh_token on refresh, so we keep the existing one
		} else {
			store.commit("userVUEX/SET_TOKEN", "");
			store.commit("userVUEX/SET_REFRESH_TOKEN", "");
			store.commit("userVUEX/setUserInfo", {});
			store.dispatch("userVUEX/LogOut");
		}
	} catch (error) {
		if (axios.isCancel(error) || ["ECONNABORTED", "ERR_CANCELED"].includes(error.code)) {
			return;
		}
		store.commit("userVUEX/SET_TOKEN", "");
		store.commit("userVUEX/SET_REFRESH_TOKEN", "");
		store.commit("userVUEX/setUserInfo", {});
		store.dispatch("userVUEX/LogOut");
	}
};

// Unified function to refresh access token based on login type
export const refreshAccessToken = async () => {
	const loginData = getLoginType();
	if (loginData && loginData.logged_in === "google") {
		// User logged in via Google - use Google refresh endpoint
		await refreshGoogleToken();
	} else {
		// User logged in via Keycloak - use existing refresh flow
		await getNewAccessToken();
	}
};

// Keycloak refresh-token grant for the tracking SDK; returns the token response.
export const refreshKeycloakToken = (refreshToken) => {
	return SSOService({
		url: `auth/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`,
		method: "post",
		data: qs.stringify({
			grant_type: "refresh_token",
			client_id: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
			refresh_token: refreshToken,
		}),
	});
};
function getProfileID() {
	var userID = store.state.candidateVUEX.candidateInfo._id;
	// Fallback: candidateInfo may not be populated yet on first load after
	// registration redirect (setCandidateInfo fires async via router guard).
	// primaryCandidateInfo is populated earlier by ensureCandidateInfoForInitialGate.
	if (!userID) {
		userID =
			store.state.candidateVUEX.primaryCandidateInfo?._id ||
			store.getters["candidateVUEX/getPrimaryCandidateInfo"]._id;
	}
	return userID;
}
export const converter = (data) => {
	return conv({
		url: "nodehtmltopdf",
		method: "POST",
		data,
	});
};

export const converterAtsPreview = (data) => {
	return atsPreview({
		url: "screenshot",
		method: "POST",
		responseType: "blob",
		data,
	});
};

export function tetrisAPI(templateID, headers) {
	return tetrisURL({
		url: "/template?template=" + templateID,
		method: "post",
		headers,
	});
}

// SSO API

export const postCandInfo = (data) => {
	return ServiceCandidate({
		url: "can/candidate-information/",
		method: "post",
		data,
	});
};

export const saveJobPreference = (data) => {
	return ServiceCandidate({
		url: "can/job-preference/",
		method: "Put",
		data,
	});
};

export const raiseReport = (data) => {
	return ServiceCandidate({
		url: "user/raise-ticket/",
		method: "post",
		data,
	});
};

export const getJobPreference = (email) => {
	return ServiceCandidate({
		url: "can/job-preference/?email=" + email,
		method: "get",
	});
};

export const postInstructorInformation = (data) => {
	return serviceRequest({
		url: "/training/instructor-kanban/",
		method: "post",
		data,
	});
};

export const instructorRoleExists = (data) => {
	return serviceRequest({
		url: "/training/instructor-check-existing-role/?email=" + data,
		method: "get",
	});
};

export const getInterviewGraph = (data) => {
	return serviceRequest({
		url:
			"pan/interviews-taken-graph/?timeline=" +
			data.selectedTimeline +
			"&quantity=" +
			data.quantity +
			"&unit=" +
			data.unit +
			"&userID=" +
			data.userID +
			"&includes=" +
			data.includes,
		method: "get",
	});
};
export const saveInterviewSlot = (data) => {
	return ServiceCandidate({
		url: "/job/select-slots/",
		method: "post",
		data,
	});
};

export const saveInterviewSlotPanel = (data) => {
	return ServiceCandidate({
		url: "/pan/final-round-slot-preference/",
		method: "post",
		data,
	});
};

export const deleteImage = (name) => {
	return ServiceCandidate({
		url: "user/static-image/?name=" + name,
		method: "GET",
	});
};

export const staticImage = (name) => {
	return ServiceCandidate({
		url: "user/static-image/?name=" + name,
		method: "GET",
	});
};

export const getProfileSkills = () => {
	return ServiceCandidate({
		url: "/user/candidate-roadmap-controller/",
		method: "get",
	});
};

export const getAssessmentSuggestions = (data) => {
	return ServiceCandidate({
		url: "/user/candidate-roadmap-skill-assessment-suggestion/",
		method: "post",
		data: data,
	});
};

export const getSkillRoadmapSuggestions = (data) => {
	return ServiceCandidate({
		url: "/user/candidate-roadmap-controller/",
		method: "post",
		data: data,
	});
};

export const getCandInfo = (id = null) => {
	// const uuid = getResumeuuid();
	const myId = id ? id : getProfileID();
	const params = {};
	params.id = myId;
	return ServiceCandidate({
		url: "can/user-parser/",
		method: "get",
		params,
	});
};

export const switchProfile = () => {
	return ServiceCandidate({
		url: "can/user-parser/",
		method: "get",
	});
};

export const markResumeVerified = (data) => {
	return ServiceCandidate({
		url: "can/user-parser/",
		method: "post",
		data: data,
	});
};

export const deleteAccount = (data) => {
	return ServiceCandidate({
		url: "user/send-otp/",
		method: "post",
		data,
	});
};
export const getAllProfiles = (data) => {
	return ServiceCandidate({
		url: "can/profiles/",
		method: "get",
		params: {
			id: getProfileID(),
			searchQuery: data,
		},
	});
};

export const postAllProfiles = (data) => {
	return ServiceCandidate({
		url: "can/profiles/",
		method: "post",
		data,
	});
};
export const userInfo = () => {
	return ServiceCandidate({
		url: "/can/register",
		method: "get",
	});
};

export const candidateActions = (data) => {
	return ServiceCandidate({
		method: "put",
		url: "/user/candidate-actions",
		data,
	});
};

export const tempResume = (data) => {
	return serviceRecruitment({
		url: `/common/temp-resume/`,
		method: "post",
		data,
	});
};

export const myProfile = () => {
	return ServiceCandidate({
		url: "/user/my-profile/",
		method: "get",
	});
};
export const getIndustries = () => {
	return ServiceCandidate({
		url: "/pan/industries/",
		method: "get",
		//   headers: { userID: "613ae10c-7056-4868-b51b-c19b6977c7c" }
	});
};

export const postPanelInformation = (data) => {
	return ServiceCandidate({
		url: "/pan/panel-information/",
		method: "post",
		data,
		//   headers: { userID: "613ae10c-7056-4868-b51b-c19b6977c7c" }
	});
};
export const postPanelResult = (data) => {
	return ServiceCandidate({
		url: "/pan/panel-application-results/",
		method: "post",
		data,
		//   headers: { userID: "613ae10c-7056-4868-b51b-c19b6977c7c" }
	});
};
export const AtsResume = (data) => {
	return ServiceCandidate({
		url: `/can/candidate-resume-render/?template=${data.template}&id=${data.id}`,
		method: "get",
		data,
	});
};

export const postCandParser = (data) => {
	return ServiceCandidateParser({
		url: "parser-v2/",
		method: "post",
		data,
	});
};

export const getProfileCompletion = (userIds = "") => {
	return ServiceCandidate({
		url: "user/profile-progress/",
		method: "get",
		params: {
			id: userIds == "" ? getProfileID() : userIds,
		},
	});
};

export const getRoadmapRecommendedJobs = (data) => {
	return ServiceCandidateParser({
		url: "/ai/suggest-company-details/",
		method: "post",
		data,
	});
};

export const extractSkills = (data) => {
	return ServiceCandidateParser({
		url: "/ai/extract-skills/",
		method: "post",
		data,
	});
};

//For the top Tabs Name
export const getProfileTopTabs = (data, pType) => {
	return ServiceCandidate({
		url: "/user/industry-configuration/",
		method: "get",
		params: {
			industryName: data,
			type: pType,
			id: getProfileID(),
		},
	});
};

export const dynamicMandetoryFields = (data, id = null) => {
	return ServiceCandidate({
		url: "user/forms-configuration/",
		method: "get",
		params: {
			experienceName: data,
			id: id ? id : getProfileID(),
		},
	});
};

export const dynamicMandetoryFieldsForNew = () => {
	return ServiceCandidate({
		url: "user/forms-configuration/",
		method: "get",
		params: {
			type: "new",
		},
	});
};

export const addPortfolio = (data) => {
	return ServiceCandidate({
		url: "can/candidate-portfolio/",
		method: "post",
		data,
	});
};
export const patchPortfolio = (data) => {
	return ServiceCandidate({
		url: "can/candidate-portfolio/",
		method: "patch",
		data,
	});
};
export const getDocumentDetails = (data) => {
	return ServiceCandidate({
		url: "can/reupload-documents/",
		method: "get",
		data,
	});
};
export const getAllUploadedDocuments = (data) => {
	return ServiceCandidate({
		url: "can/get-documents/",
		method: "get",
		params: {
			jobID: data.jobID,
		},
	});
};

export function checkimageresponse(data) {
	return imageVerify({
		url: `face_detection/`,
		method: "post",
		data,
	});
}

export const uploadCandidadateDocuments = (data) => {
	return ServiceCandidate({
		url: "can/reupload-documents/",
		method: "put",
		data,
	});
};

export function candidateImage(data) {
	return ServiceCandidate({
		url: `/can/candidate-video-resume/`,
		method: "post",
		data,
	});
}

export function deleteCandidateResume(data) {
	return ServiceCandidate({
		url: `/can/candidate-video-resume/`,
		method: "delete",
		data,
	});
}

export function getQuestionsForVideoResume(data) {
	return ServiceCandidate({
		url: `/can/candidate-video-resume-ref/`,
		method: "get",
		params: {
			id: getProfileID(),
		},
	});
}

export const postCandExp = (data) => {
	return ServiceCandidate({
		url: "can/candidate-experience/",
		method: "post",
		data,
	});
};
export const patchCandExp = (data) => {
	return ServiceCandidate({
		url: "can/candidate-experience/",
		method: "patch",
		data,
	});
};

export const putCandExp = (data) => {
	return ServiceCandidate({
		url: "can/candidate-experience/",
		method: "put",
		data,
	});
};

export const deleteCandExp = (data) => {
	return ServiceCandidate({
		url: "can/candidate-experience/",
		method: "delete",
		data,
	});
};

export const postCandEdu = (data) => {
	return ServiceCandidate({
		url: "can/candidate-education/",
		method: "post",
		data,
	});
};

export const putCandEdu = (data) => {
	return ServiceCandidate({
		url: "can/candidate-education/",
		method: "put",
		data,
	});
};

export const patchCandEdu = (data) => {
	return ServiceCandidate({
		url: "can/candidate-education/",
		method: "patch",
		data,
	});
};

export const putCandSkills = (data) => {
	return ServiceCandidate({
		url: "can/candidate-skills/",
		method: "put",
		data,
	});
};

export const postCandSkills = (data) => {
	return ServiceCandidate({
		url: "can/candidate-skills/",
		method: "post",
		data,
	});
};
export const postCandInterSkills = (data) => {
	return ServiceCandidate({
		url: "can/candidate-interpersonal-skills/",
		method: "post",
		data,
	});
};
export const patchCandSkills = (data) => {
	return ServiceCandidate({
		url: "can/candidate-skills/",
		method: "patch",
		data,
	});
};
export const patchCandInterSkills = (data) => {
	return ServiceCandidate({
		url: "can/candidate-interpersonal-skills/",
		method: "patch",
		data,
	});
};

export const deleteCandskills = (data) => {
	return ServiceCandidate({
		url: "can/candidate-skills/",
		method: "delete",
		data,
	});
};

export const deleteCandEdu = (data) => {
	return ServiceCandidate({
		url: "can/candidate-education/",
		method: "delete",
		data,
	});
};

export const getCompleted = () => {
	return ServiceCandidate({
		url: "can/v4/candidateAssessmentProgress/",
		method: "get",
		params: {
			emailID: getUserMail(),
		},
	});
};
export const getAssessProg = () => {
	return ServiceCandidate({
		url: "can/upcoming-ongoing-assessments/",
		method: "get",
		params: {
			emailID: getUserMail(),
			dashboard: true,
		},
	});
};

export const getCompAndProg = () => {
	return ServiceCandidate({
		url: "can/upcoming-ongoing-assessments/",
		method: "get",
		params: {
			emailID: getUserMail(),
		},
	});
};

export const postProjectsInfo = (data) => {
	return ServiceCandidate({
		url: "can/candidate-projects/",
		method: "post",
		data,
	});
};
export const patchProjectsInfo = (data) => {
	return ServiceCandidate({
		url: "can/candidate-projects/",
		method: "patch",
		data,
	});
};

export const putProjectEdit = (data) => {
	return ServiceCandidate({
		url: "can/candidate-projects/",
		method: "put",
		data,
	});
};

export const deleteCandProject = (data) => {
	return ServiceCandidate({
		url: "can/candidate-projects/",
		method: "delete",
		data,
	});
};

export const postCandDomain = (data) => {
	return ServiceCandidate({
		url: "can/candidate-domain/",
		method: "post",
		data,
	});
};

export const putCandDomain = (data) => {
	return ServiceCandidate({
		url: "can/candidate-domain/",
		method: "put",
		data,
	});
};

export const deleteCandDomain = (data) => {
	return ServiceCandidate({
		url: "can/candidate-domain/",
		method: "delete",
		data,
	});
};

//For achievement type Certificate
export const postCandAchieveFileUpload = (data) => {
	return ServiceCandidate({
		url: "can/document-achievements/",
		method: "post",
		data,
	});
};

export const postCandAchieve = (data) => {
	return ServiceCandidate({
		url: "can/candidate-achievement/",
		method: "post",
		data,
	});
};
export const patchCandAchieve = (data) => {
	return ServiceCandidate({
		url: "can/candidate-achievement/",
		method: "patch",
		data,
	});
};

export const putCandAchieve = (data) => {
	return ServiceCandidate({
		url: "can/candidate-achievement/",
		method: "put",
		data,
	});
};

export const deleteCandAchieve = (data) => {
	return ServiceCandidate({
		url: "can/candidate-achievement/",
		method: "delete",
		data,
	});
};

//For achievement type Event

export const postCandEvent = (data) => {
	return ServiceCandidate({
		url: "can/candidate-events/",
		method: "post",
		data,
	});
};
export const patchCandEvent = (data) => {
	return ServiceCandidate({
		url: "can/candidate-events/",
		method: "patch",
		data,
	});
};

export const putCandEvent = (data) => {
	return ServiceCandidate({
		url: "can/candidate-events/",
		method: "put",
		data,
	});
};

export const deleteCandEvent = (data) => {
	return ServiceCandidate({
		url: "can/candidate-events/",
		method: "delete",
		data,
	});
};

//For achievement type Award
export const postCandAward = (data) => {
	return ServiceCandidate({
		url: "can/candidate-awards/",
		method: "post",
		data,
	});
};
export const patchCandAward = (data) => {
	return ServiceCandidate({
		url: "can/candidate-awards/",
		method: "patch",
		data,
	});
};

export const putCandAward = (data) => {
	return ServiceCandidate({
		url: "can/candidate-awards/",
		method: "put",
		data,
	});
};

export const deleteCandAward = (data) => {
	return ServiceCandidate({
		url: "can/candidate-awards/",
		method: "delete",
		data,
	});
};

export const deleteCandPortfolio = (data) => {
	return ServiceCandidate({
		url: "can/candidate-portfolio/",
		method: "delete",
		data,
	});
};

export const putCandPortfolio = (data) => {
	return ServiceCandidate({
		url: "can/candidate-portfolio/",
		method: "put",
		data,
	});
};

export const userLogin = (data, headers) => {
	return KeynodeService({
		url: `token`,
		method: "post",
		headers: headers,
		data,
	});
};

export const userLogOut = (data, headers) => {
	return SSOService({
		url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
		method: "post",
		headers: headers,
		data,
	});
};

export const getAssessmentProgress = () => {
	return ServiceCandidate({
		method: "get",
		url: "can/v2/candidateAssessmentProgress/",
		params: {
			emailID: getUserMail(),
			// emailID:"goutham.e@simplify3x.com",
		},
	});
};

export const getCandDetails = () => {
	return ServiceCandidate({
		method: "get",
		url: "can/v2/candidateDetails/",
		params: {
			emailID: getUserMail(),
		},
	});
};

export const getQrCode = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "can/qr-code-gen/",
		params: {
			emailID: data,
		},
	});
};

export const getCandDetailsV3 = () => {
	return ServiceCandidate({
		method: "get",
		url: "can/v3/candidateDetails/",
	});
};

export const uploadDocuments = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "can/candidateDocuments/",
		data,
	});
};

// export const getDocuments = () => {
//   return ServiceCandidate({
//     method: "get",
//     url: "can/candidateDocuments/",
//     params: {
//       email: getUserMail(),
//     },
//   });
// };

export const getDocuments = () => {
	return ServiceCandidate({
		method: "get",
		url: "can/v3/candidateDocuments/",
	});
};

// export const putDocument = (data) => {
//   return ServiceCandidate({
//     method: "put",
//     url: "can/candidateDocuments/",
//     data,
//   });
// };

export const putDocument = (data) => {
	return ServiceCandidate({
		method: "put",
		url: "can/v3/candidateDocuments/",
		data,
	});
};

export const postDocument = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "can/v3/candidateDocuments/",
		data,
	});
};

export const saveResume = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "can/profiles/",
		data,
	});
};

export const renameResume = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "can/profiles/",
		data,
	});
};

export const deleteNormalProfile = (data) => {
	return ServiceCandidate({
		method: "delete",
		url: "can/candidate-information/",
		data,
	});
};

export const deletePrimaryProfile = (data) => {
	return ServiceCandidate({
		method: "delete",
		url: "can/candidate-information/",
		data,
	});
};

export const logDownload = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "user/resume-download/",
		data,
	});
};
export const downloadGraphicalResume = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "can/download-resume/",
		data,
	});
};

export const deleteDocument = (data) => {
	return ServiceCandidate({
		method: "delete",
		url: "can/v3/candidateDocuments/",
		data,
	});
};

export const patchDocument = (data) => {
	return ServiceCandidate({
		method: "patch",
		url: "can/candidateDocuments/",
		data,
	});
};

export const getJdDetail = (jobID) => {
	return ServiceCandidate({
		url: "can/v2/candidateJDProgress/",
		method: "get",
		params: {
			jobID: jobID,
		},
	});
};
export const jDProgress = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "can/v3/candidateJDProgress/",
		data,
	});
};
export const dashboardJDProgress = () => {
	return ServiceCandidate({
		url: "can/dashboard-jd-progress/",
		method: "get",
	});
};
export const checkCandidate = () => {
	return EmailService({
		url: "can/login/",
		method: "get",
	});
};

//JOB-Search API
export const postJobSearch = (data) => {
	return ServiceCandidate({
		url: "/job/job-search/",
		method: "post",
		data,
	});
};

//Apply-jobs API
export const postApplyJob = (data) => {
	return ServiceCandidate({
		url: "/job/job-apply/",
		method: "post",
		data,
	});
};

//Bookmark job Api
export const postBookmarkJob = (data) => {
	return ServiceCandidate({
		url: "/job/bookmark-job/",
		method: "post",
		data,
	});
};

//Withdraw job Api
export const postWithdrawJob = (data) => {
	return ServiceCandidate({
		url: "/job/job-withdraw/",
		method: "post",
		data,
	});
};

//Particular job API
export const getParticularJob = (data) => {
	return ServiceCandidate({
		url: `/job/job-search-single-job/`,
		method: "get",
		params: {
			jobID: data.jobID,
			emailID: data.emailID,
		},
	});
};

//GET OFFER LETTER ---- OLD
export const getOfferLetter = (data) => {
	return ServiceCandidate({
		url: "recruitment/statusUpdate/",
		method: "get",
		params: {
			uuid: data.uuid,
			licenseKey: data.licenseKey,
			type: data.type,
		},
	});
};

//GET OFFER LETTER ---- NEW
export const getLetter = (data) => {
	return ServiceCandidate({
		url: `recruitment/offerLetterDetails/?licenseKey=${data.licenseKey}`,
		method: "get",
	});
};

// REJECT OR ACCEPT LETTER AND EMPLOYEE REGISTRATION
export const actionOnLetter = (data) => {
	return ServiceCandidate({
		url: "recruitment/statusUpdate/",
		method: "post",
		data,
	});
};

// GET DOCUMENTS HR
export const getDocumentsHR = () => {
	return ServiceCandidate({
		url: "recruitment/hro/sendtocandidate/",
		method: "get",
	});
};

// GET DOCUMENTS HR
export const getTaggedDecDocs = (data) => {
	return ServiceCandidate({
		url: `recruitment/dec-documents/`,
		method: "get",
		params: {
			licenseKey: data.licenseKey,
			uuid: data.uuid,
		},
	});
};

export const postTaggedDecDocs = (data) => {
	return ServiceCandidate({
		url: `recruitment/dec-documents/`,
		method: "post",
		data,
	});
};
export const fakeToken = () => {
	return KeycloakAPIs({
		url: "/fakejwttoken/",
		method: "GET",
	});
};

export function getUserMail() {
	var decoded = jwt_decode(getToken());
	return decoded.email;
}

export const forgotPassword = (email) => {
	return KeycloakAPIs({
		url: `forgot-password/?email=${email}`,
		method: "get",
	});
};
export const sendOTP = (email, type = "forgot-password") => {
	return ServiceCandidate({
		url: "user/send-otp/",
		method: "post",
		data: {
			email: email,
			type: type, // 'forgot-password' or 'register'
		},
	});
};

export const saveProfileDetails = (data) => {
	return ServiceCandidate({
		url: `/can/profile-info/`,
		method: "put",
		data,
	});
};

export const getJobDocuments = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "/can/upload-documents/",
		data,
	});
};

export const getexitingdocuments = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "/can/required-documents/",
		data,
	});
};

export const uploadjdDocuments = (data) => {
	return ServiceCandidate({
		url: `can/v3/candidateDocuments/`,
		method: "post",
		data,
	});
};
export const getJdRoundMarks = (data) => {
	return serviceRecruitment({
		url: `pan/get-assessment-response/?interviewID=${data}`,
		method: "get",
		data,
	});
};
export const postCourse = (data) => {
	return trainingService({
		url: `marketplace/courses/`,
		method: "post",
		data: {
			...data,
		},
	});
};

export const getcoursesList = (data) => {
	return trainingService({
		url: `marketplace/courses/`,
		method: "post",
		data,
	});
};

export const toggleWishlist = (data, isAdding) => {
	return trainingService({
		url: `marketplace/wishlist/`,
		method: isAdding ? "post" : "delete",
		data,
	});
};

export const postCourseList = (data) => {
	return trainingService({
		url: `candidate/my-course/`,
		method: "post",
		data,
	});
};

export const udemyCourses = () => {
	return serviceRecruitment({
		url: "search/course-suggestions/",
		method: "post",
	});
};
// reset password
export const reset_password = (data) => {
	return ServiceCandidate({
		url: `user/reset-password/`,
		method: "put",
		data,
	});
};

export const resetPassword = (data) => {
	return KeycloakAPIs({
		url: `reset-password/`,
		method: "put",
		data,
	});
};

// get profile details
export const getProfileDetails = (data) => {
	return KeycloakAPIs({
		url: `/verifyemail/?email=${data.email}`,
		method: "get",
		data,
	});
};

export const getUserDetails = (data) => {
	return ServiceCandidate({
		url: `/can/profile-info/`,
		method: "get",
		data,
	});
};
export const getUserSettings = (data) => {
	return ServiceCandidate({
		url: `/user/v2/settings/`,
		method: "get",
		data,
	});
};
export const changeUserSettings = (data) => {
	return ServiceCandidate({
		url: `/user/v2/settings/`,
		method: "put",
		data,
	});
};
// get appilcations
export const getApplications = () => {
	return KeycloakAPIs({
		url: `/applications/`,
		method: "get",
	});
};
// sign Out alldevices
export const signOutAllDevices = () => {
	return KeycloakAPIs({
		url: `/signout/`,
		method: "delete",
	});
};
// sign out
export const signOutDevices = (data) => {
	return KeycloakAPIs({
		url: `/signout/?id=${data.id}`,
		method: "delete",
		data,
	});
};

// get profile info
export const getProfileInfo = (data) => {
	return KeycloakAPIs({
		url: "/update-user/",
		method: "put",
		data,
	});
};

// get device activity
export const getDeviceActivity = () => {
	return KeycloakAPIs({
		url: "/device-activity/",
		method: "get",
	});
};

export const getPreference = () => {
	return websiteRequest({
		url: `user-preference/`,
		method: "get",
	});
};
//get user access to projects
export const userAccess = () => {
	return KeycloakAPIs({
		url: "user-access/",
		method: "get",
	});
};

export const postPreference = (data) => {
	return websiteRequest({
		url: `user-preference/`,
		method: "post",
		data,
	});
};
export const getPublicTests = () => {
	return ServiceCandidate({
		url: "/assessment/v2/public-test",
		method: "get",
	});
};

export const startTest = (data) => {
	return ServiceCandidate({
		url: "/assessment/v2/public-test",
		method: "post",
		data,
	});
};

export const getTempPath = (data) => {
	return ServiceCandidate({
		url: "/can/candidate-video-resume/?id=" + data,
		method: "put",
	});
};

export const postVideoResume = (data) => {
	return ServiceCandidate({
		url: `/can/candidate-video-resume/`,
		method: "post",
		data: {
			...data,
			id: getProfileID(),
		},
	});
};
export const getPublicProfileDetails = (data) => {
	return ServiceCandidate({
		url: `/user/public-profile/`,
		method: "get",
		params: {
			username: data.username,
			loggedIn: data.loggedIn,
		},
	});
};

export const getResumeTemp = (template, waterMark = false, id = null) => {
	return ServiceCandidate({
		url: "/can/candidate-resume-render/",
		method: "get",
		params: {
			template,
			waterMark,
			id: id ? id : getProfileID(),
		},
	});
};
export const setPrimaryProfile = (data) => {
	return ServiceCandidate({
		url: `/can/change-primary/`,
		method: "put",
		data,
	});
};

export const getSuggestion = (data) => {
	return requestSuggestion({
		url: "/get-skills/",
		method: "get",
		params: {
			searchQuery: data,
		},
	});
};

export const getSkillSuggestions = (data) => {
	return requestSuggestion({
		url: "/suggest-skills/",
		method: "get",
		params: data,
	});
};

export const getSuggestionCompany = (data) => {
	return requestSuggestion({
		url: "/companies/",
		method: "post",
		data,
	});
};
export const getSuggestionCollege = (data) => {
	return requestSuggestion({
		url: "/colleges/",
		method: "post",
		data,
	});
};

export const enableProfile = (data) => {
	return ServiceCandidate({
		url: "/user/v2/settings/",
		method: "put",
		data,
	});
};

export const getUserCredits = () => {
	return ServiceCandidate({
		url: "/user/purchase-credits/",
		method: "get",
	});
};

export const addUserCredits = (data) => {
	return ServiceCandidate({
		url: "/user/purchase-credits/",
		method: "post",
		data,
	});
};

export const createOrder = (data) => {
	return paymentService({
		url: "/order/v2",
		method: "post",
		data,
	});
};

export const goToPayment = (orderID) => {
	return paymentService({
		url: "/transaction/payment-page/",
		method: "get",
		params: {
			orderID: orderID,
		},
	});
};

export const checkCustomerExists = (useremail) => {
	return paymentService({
		url: "/customer/customer-check/",
		method: "get",
		params: {
			email: useremail,
		},
	});
};

export const createCustomer = (data) => {
	return paymentService({
		url: "/customer/",
		method: "post",
		data,
	});
};

export const getLocation = (data) => {
	return ServiceCandidate({
		url: "/user/get-location/",
		method: "post",
		data,
	});
};

export const postNotifications = (data) => {
	return serviveNotification({
		url: `/notification/`,
		method: "post",
		data: {
			...data,
			userID: getProcessedToken(),
		},
	});
};

export const getNotifications = () => {
	return serviveNotification({
		url: `/notification/`,
		method: "get",
		params: {
			userID: getProcessedToken(),
			eventID: "savedFirstProfile",
		},
	});
};

export const putNotification = (data) => {
	return serviveNotification({
		url: "/notification/",
		method: "put",
		data,
	});
};
export const profileActivities = () => {
	return ServiceCandidate({
		url: "/user/recent-activities/",
		method: "get",
	});
};

// For referral
export const getCandReferral = () => {
	return ServiceCandidate({
		url: "/user/referal-count/",
		method: "get",
		params: {
			id: getProfileID(),
		},
	});
};

// Assessment Progress
export const getShareLink = (payload) => {
	return ServiceCandidate({
		url: "/assessment/v2/public-test/",
		method: "post",
		data: {
			...payload,
		},
	});
};

export const getPublicAssessments = (data) => {
	return ServiceCandidate({
		url: "/assessment/v4/get-public-test/",
		method: "post",
		data,
	});
};

export const getAllAssessments = (data) => {
	return ServiceCandidate({
		url: "/can/all-status-assessment-progress-v2/",
		method: "post",
		data,
	});
};

export const getCompletedAssessments = (emailID) => {
	return ServiceCandidate({
		url: "/can/v4/candidateAssessmentProgress/",
		method: "get",
		params: {
			emailID,
		},
	});
};

export const getUpcomingAndOngoingAssessments = (emailID) => {
	return ServiceCandidate({
		url: "/can/upcoming-ongoing-assessments/",
		method: "get",
		params: {
			emailID,
		},
	});
};

export const getCategories = (data) => {
	return ServiceCandidate({
		url: "/assessment/categories/",
		method: "get",
		params: {
			searchQuery: data.searchQuery,
			home: data.home,
		},
	});
};

export const getSubCategories = (payload) => {
	return ServiceCandidate({
		url: "/assessment/sub-categories/",
		method: "get",
		params: payload,
	});
};

export const getMarks = (payload) => {
	return ServiceCandidate({
		url: "/can/view-marks/",
		method: "get",
		params: {
			...payload,
		},
	});
};

export const getPromotions = (params) => {
	return ServiceCandidate({
		url: "/user/promotion/",
		method: "get",
		params,
	});
};

//Cancel Upload
export const cancelUpload = () => {
	return ServiceCandidate({
		url: "/can/cancel-upload/",
		method: "delete",
		params: {
			id: getProfileID(),
		},
	});
};
//Home page
export const getProfileViews = (params) => {
	return ServiceCandidate({
		url: "/user/home-page/",
		method: "get",
		params,
	});
};

// Job Search APIs
export const getJobs = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "/job/job-search/",
		data,
	});
};
export const getCuratedJobs = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "/job/curated-jobs/",
		data,
	});
};

export const applyCuratedJobs = (data) => {
	return ServiceCandidate({
		method: "put",
		url: "/job/curated-jobs/",
		data,
	});
};
export const postApplication = (data) => {
	return trainingService({
		method: "post",
		url: "/instructor/application/",
		data,
	});
};

export const getTopCompanies = (count) => {
	return ServiceCandidate({
		method: "get",
		url: "/job/get-top-companies/",
		params: {
			count,
		},
	});
};
export const getSalaryRange = () => {
	return ServiceCandidate({
		method: "get",
		url: "/job/salary-range/",
	});
};

export const getJobTypes = () => {
	return ServiceCandidate({
		method: "get",
		url: "/job/job-type/",
	});
};

export const getLocations = () => {
	return ServiceCandidate({
		method: "get",
		url: "/job/get-locations/",
	});
};

export const toggleBookmark = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "/job/bookmark-job/",
		data,
	});
};

export const getCustomerFields = (data) => {
	return serviceRecruitment({
		method: "get",
		url: "/common/form-config/",
		params: {
			...data,
		},
	});
};

export const getCustomFields = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "/job/applied-job/",
		params: {
			jobID: data.jobID,
			email: data.email,
			licenseKey: data.licenseKey,
		},
	});
};

export const getCandidatePrimaryProfile = () => {
	return ServiceCandidate({
		url: "can/user-parser/",
		method: "get",
	});
};

export const applyJob = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "/job/job-apply/",
		data,
	});
};

export const getCandidateFilePaths = (pId) => {
	return ServiceCandidate({
		method: "get",
		url: `/job/job-apply/?id=${pId}`,
	});
};

export const uploadJobDocuments = (data) => {
	return ServiceCandidate({
		method: "patch",
		url: "/job/job-apply/",
		data,
	});
};

export const withdrawApplication = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "/job/job-withdraw/",
		data,
	});
};

export const getInterviewDetails = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "/can/interview-history/",
		params: data,
	});
};

export const getCvsDetails = () => {
	return ServiceCandidate({
		method: "get",
		url: "/pan/application-status/",
	});
};

export const triggerCvs = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "/pan/retrigger-request/",
		data,
	});
};
export const getCandStreak = (data) => {
	return ServiceCandidate({
		url: "/user/streaks/",
		method: "get",
		params: {
			id: getProfileID(),
			...data,
		},
	});
};
//New api for profile treaks only : /user/profile/streaks/?startDate=2025-01
export const getProfileStreak = (data) => {
	return ServiceCandidate({
		url: "/user/profile/streaks/",
		method: "get",
		params: {
			...data,
		},
	});
};

//Panel Dashboard Streaks
export const getPanelStreak = (data) => {
	return ServiceCandidate({
		url: "/pan/panel-earning-graph/",
		method: "post",
		data,
	});
};

//Tasks
export const getTaskData = () => {
	return ServiceCandidate({
		url: "/can/tasks/",
		method: "get",
		params: {
			id: getProfileID(),
		},
	});
};

export const getDocumentDash = () => {
	return ServiceCandidate({
		url: "/can/tasks/",
		method: "get",
		params: {
			document: true,
		},
	});
};

export const getSearchHistory = () => {
	return ServiceCandidate({
		url: "/job/job-search-history/",
		method: "get",
	});
};

export const getSearchHistoryDashboard = (data) => {
	return ServiceCandidate({
		url: "/user/search-history/",
		method: "get",
		params: data,
	});
};

export const postSearchHistoryDashboard = (data) => {
	return ServiceCandidate({
		url: "/user/search-history/",
		method: "post",
		data,
	});
};

export const deleteSearchHistoryDashboard = (data) => {
	return ServiceCandidate({
		url: "/user/search-history/",
		method: "delete",
		data,
	});
};

// Anonymous Search History APIs
export const getAnonymousSearchHistory = (params) => {
	return ServiceCandidate({
		url: "user/search-history/anonymous/",
		method: "get",
		params,
	});
};

export const postAnonymousSearchHistory = (data) => {
	return ServiceCandidate({
		url: "user/search-history/anonymous/",
		method: "post",
		data,
	});
};

export const deleteAnonymousSearchHistory = (data) => {
	return ServiceCandidate({
		url: "user/search-history/anonymous/",
		method: "delete",
		data,
	});
};

export const migrateGuestSearchHistory = (uuid) => {
	return ServiceCandidate({
		url: "user/search-history/migrate/",
		method: "post",
		data: { uuid },
	});
};

export const getSearchSuggestions = (data) => {
	return ServiceCandidate({
		url: "/user/search-suggetion/",
		method: "get",
		params: data,
	});
};
export const getPriorityList = () => {
	return ServiceCandidate({
		url: "/user/dashboard-view/",
		method: "get",
	});
};

// Testers' insights panel (accounts listed in the backend's HUD_USER_IDS).
export const getHudInsights = ({ recommendations = false, history = false } = {}) => {
	const params = {};
	if (recommendations) params.recommendations = 1;
	if (history) params.history = 1;
	return ServiceCandidate({
		url: "/user/hud-view/",
		method: "get",
		params,
	});
};

// Wipes the signed-in candidate's behaviour data (events, signals, profile). Listed testers only.
export const resetHudProfile = () => {
	return ServiceCandidate({
		url: "/user/hud-view/reset/",
		method: "post",
	});
};

// export const getAssesmentCategory = (data) => {
// 	return trainingService({
// 	  method: "get",
// 	  url: "http://127.0.0.1:8000/assessment/categories",
// 	  params: {
// 		...data
// 	  }
// 	});
//   };
export const getCourseSuggestion = (data) => {
	return trainingService({
		url: `marketplace/top-search/`,
		method: "get",
		params: data,
	});
};

export const submitGameScore = (type, data) => {
	return ServiceCandidate({
		url: `games/leaderboard/${type}/submit/`,
		method: "post",
		data,
	});
};
export const getLeaderBoard = (type, data) => {
	return ServiceCandidate({
		url: `games/leaderboard/${type}/`,
		method: "get",
		params: {
			page: data.page,
			count: data.count,
		},
	});
};

export const getLeaderBoards = () => {
	return ServiceCandidate({
		url: `games/leaderboards/`,
		method: "get",
	});
};

export const getCollegeLeaderBoard = (type, data) => {
	return ServiceCandidate({
		url: `games/leaderboard/collegewise/${type}/`,
		method: "get",
		params: {
			page: data.page,
			count: data.count,
		},
	});
};

export const getMyRank = (type) => {
	return ServiceCandidate({
		url: `games/leaderboard/${type}/user/`,
		method: "get",
	});
};

export const getAssessmentLeaderBoard = (category, data) => {
	return ServiceCandidate({
		url: `/assessment/assessment-leaderboard/${category}/`,
		method: "get",
		params: {
			type: data.type,
			page: data.page,
			count: data.count,
		},
	});
};
export const getGameState = (type) => {
	return ServiceCandidate({
		url: `games/state/${type}/`,
		method: "get",
	});
};
export const saveGameState = (data) => {
	return ServiceCandidate({
		url: `games/state/${data.game}/`,
		method: "post",
		data,
	});
};

export const getWords = () => {
	return ServiceCandidate({
		url: `games/wordle-words`,
		method: "get",
	});
};

export const saveActivity = (type) => {
	return ServiceCandidate({
		url: `games/state/${type}/activity/`,
		method: "get",
	});
};
export const deleteGameState = (type) => {
	return ServiceCandidate({
		url: `games/state/${type}/`,
		method: "delete",
	});
};

export const getWordList = () => {
	return ServiceCandidate({
		url: `games/wordle-words/`,
		method: "get",
	});
};
export const getAssessmentData = (data) => {
	return ServiceCandidate({
		url: "/user/completed-test/",
		method: "get",
		params: {
			emailID: data.email,
		},
	});
};
export const cvsPreCheck = (data) => {
	return serviceRecruitment({
		url: "/bgv/candidate-verfication-status/",
		method: "get",
		params: {
			uuid: data,
		},
	});
};

export const cvsImageCapture = (data) => {
	return serviceRecruitment({
		url: "/bgv/candidate-verification/",
		method: "post",
		data,
	});
};

export const finalSubmit = (data) => {
	return serviceRecruitment({
		url: "/bgv/candidate-verification/",
		method: "put",
		data,
	});
};

export const postCandInterDetails = (data) => {
	return ServiceCandidate({
		url: "user/interview-preparation/",
		method: "post",
		data,
	});
};
export const postPrepAndRevision = (data) => {
	return ServiceCandidate({
		url: "user/interview-single-skill/",
		method: "post",
		data,
	});
};

export const getCVSQuestions = (data) => {
	return serviceRecruitment({
		url: "/bgv/candidate-question/",
		method: "get",
		params: {
			uuid: data,
		},
	});
};

export const postCVSQuestion = (data) => {
	return serviceRecruitment({
		url: "/bgv/candidate-question/",
		method: "post",
		data,
	});
};

export const getNews = (data) => {
	return ServiceCandidate({
		url: "can/news/",
		method: "get",
	});
};

export const getTrendingArticles = () => {
	return ServiceCandidate({
		method: "get",
		url: "can/news-articles/",
	});
};

export const getQuotes = () => {
	return ServiceCandidate({
		method: "get",
		url: "user/daily-quotes",
	});
};

export const getQuizzes = () => {
	return ServiceCandidate({
		method: "get",
		url: "user/quiz-submission/",
	});
};
export const postQuiz = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "user/quiz-submission/",
		data,
	});
};
export const getSurvey = () => {
	return ServiceCandidate({
		method: "get",
		url: "user/survey-submission/",
	});
};

export const postSurvey = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "user/survey-submission/",
		data,
	});
};

export const getWidgetPos = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "user/profile-page-view/",
		params: data,
	});
};

export const getGovJobs = (data) => {
	return ServiceCandidate({
		method: "get",
		url: "job/governement-jobs/",
		params: {
			count: data.count,
		},
	});
};

export const getBlogs = () => {
	return ServiceCandidate({
		method: "get",
		url: "user/blog-view/",
	});
};

export const getParticularForm = (formID) => {
	return ServiceCandidate({
		method: "get",
		url: `user/forms-config`,
		params: {
			formID: formID,
			id: getProfileID(),
		},
	});
};

export const getParticularFormData = (formID) => {
	return ServiceCandidate({
		method: "get",
		url: `can/candidate-form`,
		params: {
			email:
				getUserMail() ||
				store.getters["candidateVUEX/getPrimaryCandidateInfo"].email,
			id: getProfileID(),
			form: formID,
		},
	});
};

export const getProfileSummary = (data) => {
	return ServiceCandidateParser({
		method: "post",
		url: `/ai/summary/`,
		data,
	});
};

export const getJobMatch = (data) => {
	return ServiceCandidateParser({
		method: "post",
		url: `/ai/job-match/`,
		data,
	});
};

export const createInstructor = (data) => {
	return trainingService({
		method: "post",
		url: "instructor/instructor/",
		data,
	});
};

export const getTrainingLic = () => {
	return trainingService({
		method: "get",
		url: "hire3x/license-gen/",
	});
};

// ai speech-text for project form
export const textAnalysis = (data) => {
	return ServiceCandidateParser({
		method: "post",
		url: "/ai/project/",
		data,
	});
};
export const contactUs = (data) => {
	return websiteRequest({
		url: `contact-us/`,
		method: "post",
		data,
	});
};
// Promo Code
export const applyPromoCode = (data) => {
	return ServiceCandidate({
		url: "/user/apply-promo/",
		method: "post",
		data,
	});
};

export const postLinkedinUrl = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "pan/panel-linkedin/",
		data,
	});
};

// get api for panel-notification
export const getPanelNotification = () => {
	return ServiceCandidate({
		method: "get",
		url: "pan/panel-notification/",
	});
};

export const resumeClinic = (data) => {
	return ServiceCandidateParser({
		url: `resume-clinic/`,
		method: "post",
		data,
	});
};
export const raiseATicket = (data) => {
	return serviceRecruitment({
		method: "post",
		url: "common/raise-ticket/ ",
		data,
	});
};
export const getTicketHistory = () => {
	return ServiceCandidate({
		method: "get",
		url: "user/ticket-history/",
	});
};

export const viewTicketHistory = () => {
	return ServiceCandidate({
		method: "get",
		url: "user/candidate-ticket-history/",
	});
};

export const appealRequest = (data) => {
	return ServiceCandidate({
		method: "post",
		url: "user/appeal-ticket/",
		data,
	});
};
export const setPanelSlot = (data) => {
	return ServiceCandidate({
		method: "post",
		url: `/pan/slot-preference/`,
		data,
	});
};

export const syncParser = (data) => {
	return ServiceCandidate({
		url: `can/sync-parser/`,
		method: "patch",
		data,
	});
};
export const conVerter = (data) => {
	return serviceRecruitment({
		url: "rep/resume-clinic-download/",
		method: "POST",
		responseType: "blob",
		data,
	});
};

export const resumeAnalysis = () => {
	return ServiceCandidate({
		url: "can/resume-clinic-analysis/",
		method: "GET",
	});
};
export const getPanelSlot = () => {
	return ServiceCandidate({
		method: "get",
		url: `/pan/slot-preference/`,
	});
};

export const getPanelInterviews = (data) => {
	const responseType = data.excel ? "blob" : undefined;
	return ServiceCandidate({
		method: "post",
		url: `/pan/interview-requests/`,
		data,
		responseType,
	});
};

export const rescheduleInterview = (data) => {
	return ServiceCandidate({
		method: "put",
		url: `/pan/reschedule-action/`,
		data,
	});
};
export const raiseQuery = (data) => {
	return serviceRecruitment({
		url: "/common/query/",
		method: "post",
		data,
	});
};

export const getBufferTime = (data) => {
	return ServiceCandidate({
		method: "get",
		url: `/pan/get-buffer-time-details/?testID=${data.testID}&emailID=${data.emailID}&groupID=${data.groupID}&configID=${data.configID}`,
	});
};

export const cancelInterviewRequest = (data) => {
	return ServiceCandidate({
		method: "post",
		url: `/pan/cancel-interview/`,
		data,
	});
};

export const acceptRejectInterview = (data) => {
	return ServiceCandidate({
		method: "post",
		url: `/pan/interview-actions/`,
		data,
	});
};

export const cancelInterview = (data) => {
	return ServiceCandidate({
		method: "put",
		url: `/pan/interview-actions/`,
		data,
	});
};
export const postFeedBackForm = (data) => {
	const endpoint = {
		method: "post",
		url: `/pan/v2/interview_response/`,
		data,
	};
	return serviceRecruitment(endpoint);
};
export const getfeedbackforms = (data) => {
	const config = {
		url: `int/addfeedbackform/`,
		method: "get",
		params: data,
	};
	return serviceRecruitment(config);
};
export const interviewStats = (data) => {
	const endpoint = {
		url: `/pan/interview-stats/`,
		method: "get",
		params: data,
	};
	return serviceRequest(endpoint);
};

export const getInterviewData = () => {
	return ServiceCandidate({
		method: "get",
		url: `/pan/panel-interview-stats/`,
	});
};

// Meesho Upload Documents APIs
export const getDocumentList = (data) => {
	return serviceRecruitment({
		method: "get",
		url: `/hro/can-upload-documents/`,
		params: data,
	});
};

export const checkFileExists = (data) => {
	return uploadService({
		url: "/file",
		method: "post",
		data,
	});
};

export const downloadAnyFile = (data) => {
	return serviceRecruitment({
		url: `/cus/v2/download-resume/`,
		method: "get",
		params: data,
	});
};

export const uploadAllDocuments = (data) => {
	return serviceRecruitment({
		url: "/hro/can-upload-documents/",
		method: "post",
		data,
	});
};
export const getFeedBackForm = (params) => {
	return serviceRecruitment({
		method: "get",
		url: `/pan/v2/interview_response/`,
		params,
	});
};

export const initiateCvsUpload = (data) => {
	return uploadService({
		method: "post",
		url: "file/recorded-video",
		data,
	});
};
export const finishUpload = (fileID, data) => {
	return uploadService({
		method: "patch",
		url: "file/" + fileID,
		data,
	});
};

export const getNotificationData = (data) => {
	return notificationAuth({
		url: `notification/?project=Candidate&page=${data.page}&count=${data.count}&order=${data.order}`,
		method: "get",
		data,
		params: {
			userID: data.userID,
		},
	});
};
export const markasReadNotification = (data) => {
	return notificationAuth({
		url: `notification/`,
		method: "put",
		data,
	});
};

export const markasReadandUnreadNotification = (data) => {
	return notificationAuth({
		url: `notification/`,
		method: "put",
		data,
	});
};
export const uploadPatch = (data) => {
	return uploadService({
		method: "put",
		url: "/file/recorded-video",
		data,
	});
};

export const uploadChunk = (data, signal) => {
	return uploadService({
		method: "post",
		url: "/file/upload-chunk",
		data,
		signal,
	});
};

export const clearNotification = (data) => {
	return notificationAuth({
		method: "delete",
		url: "/app-notification/",
		headers: { "userID": getProcessedToken() },
		data
	})
}

export const setMobileToken = (data) => {
	return notificationAuth({
		method: "PATCH",
		url: "/app-notification/",
		data,
		headers: { "userID": getProcessedToken() }
	})
}
export const profileView = (params) => {
	return ServiceCandidate({
		url: `/user/profile-visit-log/`,
		method: "get",
		params,
	})
}

export const rescheduleInterviewAction = (data) => {
	return ServiceCandidate({
		method: "put",
		url: `/pan/reschedule-action/`,
		data,
	});
};
export const particularMockInterviewData = (interviewId) => {
	return ServiceCandidate({
		method: "get",
		url: `/can/mock-interview/report/${interviewId}`,
	});
};
export const getmockInterviewData = (data) => {
	return ServiceCandidate({
		method: "get",
		url: `/can/mock-interview/list`,
		params: data,
	});
};

export const startMockInterview = (config) => {
	return ServiceAiInterviewer({
		method: "post",
		url: `/start-mock-interview/`,
		data: config,
	});
};

export const pollMockInterviewStatus = (interviewID) => {
	return ServiceAiInterviewer({
		method: "get",
		url: `/interview/${interviewID}/status`,
	});
};

export const stopMockInterview = (interviewID) => {
	return ServiceAiInterviewer({
		method: "post",
		url: `/interview/${interviewID}/stop`,
	});
};

export const getAssessmentReport = (data) => {
	return ServiceCandidate({
		method: "get",
		url: `/can/candidate-view-test-report/`,
		params: data,
	});
};
export const getParticipantAvatar = (data) => {
	return ServiceCandidate({
		url: `user/static-image/`,
		method: "get",
		params: {
			name: data,
		},
	});
};

export const getTrendingTags = (data) => {
	return ServiceCandidate({
		url: `job/global-trending/`,
		method: "get",
		params: data,
	});
};
// OrderCompletionController
export const postPurchaseTest = (data) => {
	return ServiceCandidate({
		url: "user/order-completion-controller/",
		method: "post",
		data,
	});
};

export const sendCandOtp = (data) => {
	return ServiceCandidate({
		url: "user/send-otp/",
		method: "post",
		data,
	});
};

export const getParticularsectionDetails = (data) => {
	return ServiceCandidate({
		url: `assessment/section-info/`,
		method: "get",
		params: {
			testID: data,
		},
	});
};
export const registerCand = (data) => {
	return ServiceCandidate({
		url: "can/register/",
		method: "post",
		data,
	});
};

export const googleLinkedInLogin = (data, token) => {
	return ServiceCandidate({
		url: `/can/auth/`,
		method: "post",
		data,
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const checkCandidateDirect = (params) => {
	return EmailService({
		url: "can/login/",
		method: "get",
		params,
	});
};

export const getParticularasmntPosition = (params) => {
	return ServiceCandidate({
		url: `assessment/user-leaderboard-position/`,
		method: "get",
		params,
	});
};

export const checkCandOtp = (data) => {
	return ServiceCandidate({
		url: `user/check-otp/`,
		method: "get",
		params: data,
	});
};

export const getParticularPublicTest = (payload) => {
	return ServiceCandidate({
		url: "/assessment/test-info/",
		method: "get",
		params: payload,
	});
};

export const getProgressHubData = () => {
	return ServiceCandidate({
		url: "can/progress-hub/?flat=true",
		method: "get",
	});
};

export const getAssessmentDetail = (params) => {
	return ServiceCandidate({
		url: "can/assessment-detail/",
		method: "get",
		params,
	});
};
export const getGlobalTrending = (data) => {
	return ServiceCandidate({
		url: "/job/global-trending/",
		method: "post",
		data,
	});
};

export const getJobAlert = (data) => {
	return ServiceCandidate({
		url: "/job/job-alert/",
		method: "post",
		data,
	});
};

export const checkJobAlert = (data) => {
	return ServiceCandidate({
		url: "/job/job-alert/",
		method: "get",
		params: data,
	});
};

// ─── S3 Pre-signed Multipart Upload ──────────────────────────────────────────

export const s3InitiateUpload = (data) => {
	return uploadService({
		method: "post",
		url: "v2/initiate/",
		data: { ...data, cvs: true },
	});
};

export const s3PresignPart = (data) => {
	return uploadService({
		method: "post",
		url: "v2/presign-part/",
		data: { ...data, cvs: true },
	});
};

export const s3StoreEtag = (data) => {
	return uploadService({
		method: "post",
		url: "v2/store-etag/",
		data: { ...data, cvs: true },
	});
};

export const s3CompleteUpload = (data) => {
	return uploadService({
		method: "post",
		url: "v2/complete/",
		data: { ...data, cvs: true },
	});
};

export const s3AbortUpload = (data) => {
	return uploadService({
		method: "post",
		url: "v2/abort/",
		data: { ...data, cvs: true },
	});
};

export const triggerTranscodeJob = (fileID, data) => {
	return uploadService({
		method: "post",
		url: "file/transcode",
		data: { fileID, ...data, cvs: true },
	});
};

export const postCandidateOnboard = (data) => {
	return ServiceCandidate({
		url: "can/candidate-onboarding/",
		method: "post",
		data,
	});
};
export const getCandidateOnboard = (params) => {
	return ServiceCandidate({
		url: "can/candidate-onboarding/",
		method: "get",
		params,
	});
};
export const updateCandidateOnboard = (data) => {
	return ServiceCandidate({
		url: "can/candidate-onboarding/",
		method: "put",
		data,
	});
};

export const userSignUp = (data) => {
	return ServiceCandidate({
		url: "/can/register/",
		method: "patch",
		data,
	});
};

export const checkCandidateSignin = (data) => {
	return ServiceCandidate({
		url: "can/check-user/",
		method: "post",
		data,
	});
};

export const getMockInterviews = () => {
	return ServiceCandidate({
		method: "get",
		url: "job/generate-mock-interview/",
	});
};

export const getCompanyAssessment = () => {
	return ServiceCandidate({
		method: "get",
		url: "assessment/company-assessments/",
	});
};
